// extracted by mini-css-extract-plugin
module.exports = {"smallBottomMargin":"d8fe8e02ebc91390ebf680bc2cc8b24c-less","featureLink":"_7f3b730cbabbfc16c312b2f9d821c8d8-less"};